/**
 * Video guida al Centro Ticket per i rappresentanti (YouTube, 11 minuti).
 * Un solo id per il link «Video guida» della coda e per la card in cima alla
 * guida. Dominio `youtube-nocookie.com`: nessun cookie finché non si riproduce.
 */
export const VIDEO_GUIDA_TICKET_ID = 'wCZ_UHG2NHg';

export const VIDEO_GUIDA_TICKET_TITLE = 'Video guida al Centro Ticket';

/** Link al video su YouTube: ripiego dello «Schermo intero» senza Fullscreen API. */
export const videoGuidaWatchUrl = (id: string = VIDEO_GUIDA_TICKET_ID): string => `https://youtu.be/${id}`;

export const videoGuidaEmbedUrl = (id: string = VIDEO_GUIDA_TICKET_ID, autoplay = false): string =>
  `https://www.youtube-nocookie.com/embed/${id}?rel=0${autoplay ? '&autoplay=1' : ''}`;
